<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="$i18n.t('userInfo.text55')"
        :visible.sync="visible"
        width="25%"
        @close="closeDialog"
        @open="openDialog"
        center>
        <el-form :model="form" size="small" :rules="rules" ref="ruleForm">
            <el-form-item>
                {{$i18n.t('userInfo.text56')}} {{ form.tel ? form.tel : form.email }}
            </el-form-item>

            <el-form-item prop="code">
                <el-input
                    v-model="form.code"
                    :placeholder="$i18n.t('userInfo.text34')">
                    <template slot="append" >
                        <el-button class="code_btn" @click="getCode" :loading="codeBtnLoading" :disabled="isCodeBtnDisabled">{{ codeBtnMsg }}</el-button>
                    </template>
                </el-input>
            </el-form-item>
<!--            <el-form-item prop="oldPassword">-->
<!--                <el-input-->
<!--                    :type="isShowPwd1 ? 'text' : 'password'"-->
<!--                    v-model.trim="form.oldPassword"-->
<!--                    maxlength="20"-->
<!--                    placeholder="旧密码（不能超过20个字符）">-->
<!--                    <i slot="suffix" :class="'pwd-icon ' + (isShowPwd1 ? 'icon-buxianzhi' : 'icon-xianzhi')"-->
<!--                       @click="isShowPwd1 = !isShowPwd1"></i>-->
<!--                </el-input>-->
<!--            </el-form-item>-->
            <el-form-item prop="newPassword">
                <el-input
                    :type="isShowPwd2 ? 'text' : 'password'"
                    v-model.trim="form.newPassword"
                    maxlength="20"
                    :placeholder="$i18n.t('userInfo.text57')">
                    <i slot="suffix" :class="'pwd-icon ' + (isShowPwd2 ? 'icon-buxianzhi' : 'icon-xianzhi')"
                       @click="isShowPwd2 = !isShowPwd2"></i>
                </el-input>
            </el-form-item>
            <el-form-item prop="againPassword">
                <el-input
                    :type="isShowPwd3 ? 'text' : 'password'"
                    v-model.trim="form.againPassword"
                    maxlength="20"
                    :placeholder="$i18n.t('userInfo.text58')">
                    <i slot="suffix" :class="'pwd-icon ' + (isShowPwd3 ? 'icon-buxianzhi' : 'icon-xianzhi')"
                       @click="isShowPwd3 = !isShowPwd3"></i>
                </el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
			<el-button @click="closeDialog">{{$i18n.t('userInfo.text35')}}</el-button>
			<el-button type="primary" :loading="loading" @click="submit">{{$i18n.t('userInfo.text36')}}</el-button>
		</span>
    </el-dialog>
</template>

<script>
import {mapState, mapActions} from "vuex";

export default {

    computed: {
        ...mapState('setting', ['updatePasswordDialogVisible']),
        ...mapState('login', ['userInfo'])
    },

    watch: {
        updatePasswordDialogVisible: {
            handler(newVal) {
                this.visible = newVal;
            }
        }
    },

    data() {
        let validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$i18n.t('userInfo.text59')))
                // password 是表单上绑定的字段
            } else if (value !== this.form.newPassword) {
                callback(new Error(this.$i18n.t('userInfo.text60')))
            } else {
                callback()
            }
        }
        return {
            loading: false,
            isShowPwd1: false,
            isShowPwd2: false,
            isShowPwd3: false,
            form: {
                tel: "",
                email: "",
                code: "",
                smsId: "",
                newPassword: "",
                againPassword: ""
            },
            phoneErr: "",
            codeBtnLoading: false,
            time: 60,
            isCodeBtnDisabled: false,
            codeBtnMsg: this.$i18n.t('userInfo.text37'),
            visible: false,
            rules: {
                oldPassword: [{required: true, message: this.$i18n.t('userInfo.text61')}],
                code: [{required: true, message: this.$i18n.t('userInfo.text39')}],
                newPassword: [
                    {required: true, message: this.$i18n.t('userInfo.text62')},
                    {pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&~#^()_\-+={}\[\]:;"'<>,.|\\/])[A-Za-z\d@$!%*?&~#^()_\-+={}\[\]:;"'<>,.|\\/]{8,}$/, message: this.$i18n.t('userInfo.text63')}
                ],
                againPassword: [{required: true, validator: validatePass2}],
            }
        }
    },

    methods: {

        ...mapActions('setting', ['closeUpdatePasswordDialog']),
        ...mapActions('login', ['loginout']),

        ...mapActions('login', ['sendUserSms', 'modifyPassword', 'modifyPasswordByPhone']),

        openDialog() {
            this.form.tel = this.userInfo.telephone;
            this.form.email = this.userInfo.email;
        },

        closeDialog() {
            this.closeUpdatePasswordDialog();
            this.$refs.ruleForm.resetFields();
            this.phoneErr = "";
            this.form = {
                tel: "",
                email: "",
                code: "",
                smsId: "",
                newPassword: "",
                againPassword: ""
            }
        },

        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.loading = true;

                    /**
                     * 最好别删除这个注释，保不齐产品那天又改需求
                     */
                    // this.modifyPassword({
                    //     oldPassword: this.$md5(this.form.oldPassword),
                    //     password: this.$md5(this.form.newPassword)
                    // }).then(res => {
                    //     this.$dialog.showMessage("修改成功,请重新登录", this.$config.TOAST_SUCCESS);
                    //     this.loginout();
                    //     // this.closeDialog();
                    //     // this.$emit('getUserInfo');
                    // }, err => {
                    //     console.log(err);
                    //     this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
                    // }).finally(() => {
                    //     this.loading = false;
                    // })

                    this.modifyPasswordByPhone({
                        code: this.form.code,
                        password: this.$md5(this.form.newPassword),
                        smsId: this.form.smsId
                    }).then(res => {
                        this.$dialog.showMessage(this.$i18n.t('userInfo.text64'), this.$config.TOAST_SUCCESS);
                        this.closeDialog();
                        this.loginout();
                    }, err => {
                        console.log(err);
                        this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
                    }).finally(() => {
                        this.loading = false;
                    })
                }
            });
        },

        getCode() {
            this.sendUserSms({
                type: '3'
            }).then(res => {
                this.form.smsId = res.result;
                this.countDown();
            }, err => {
                console.log(err);
                this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
            }).finally(() => {
                this.codeBtnLoading = false;
            })
        },

        countDown() {
            this.isCodeBtnDisabled = true;
            this.codeBtnMsg = this.time + this.$i18n.t('userInfo.text42')
            let codeTime = setInterval(() => {
                this.time--;
                this.codeBtnMsg = this.time + this.$i18n.t('userInfo.text42')
                if (this.time < 0) {
                    this.time = 60;
                    this.codeBtnMsg = this.$i18n.t('userInfo.text43')
                    this.isCodeBtnDisabled = false;
                    clearInterval(codeTime);
                }
            }, 1000)
        }

    }

}
</script>

<style scoped>

/deep/ .el-dialog {
    text-align: left !important;
}

/deep/ .el-dialog__body {
    padding-top: 0;
}

/deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
}

/deep/ .el-dialog__header {
    border-bottom: 1px solid #E9E9E9;
    padding: 13px;
}

/deep/ .el-dialog__footer {
    text-align: right;
}

.el-form {
    margin-top: 20px;
}

.code_btn {
    font-size: 10px;
    padding: 0 10px;
}

.pwd-icon {
    font-size: 14px;
    color: #757575;
    font-family: "iconfont" !important;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin-right: 10px;
    cursor: pointer;
}
</style>
